export enum eTypeReturnModal {
  ASN_BLOG_MODAL = 1,
  ASN_VIEW_MODAL = 2,
  ASN_RECEIVE_MODAL = 3,
  ASN_DELETE_MODAL = 4
}

